import { Component, Input, ElementRef, EventEmitter, Output } from '@angular/core';
declare var $: any;

@Component({
    selector: 'ups-dialog',
    template: require('./ups-dialog.component.html'),
    styles: [require('./ups-dialog.component.css')]
})
export class UpsDialogComponent {

    private _sizeModal: string = 'modal-dialog';
    @Input()
    set sizeModal(sizeModal: string) {
        switch (sizeModal) {
            case 'sm':
                this._sizeModal = 'modal-dialog modal-sm';
                break;
            case 'md':
                this._sizeModal = 'modal-dialog modal-md';
                break;
            case 'lg':
                this._sizeModal = 'modal-dialog modal-lg';
                break;
            case 'fluid':
                this._sizeModal = 'modal-dialog modal-fluid';
                break;
            default:
                //this is the same md
                this._sizeModal = 'modal-dialog';
                break;
        }
    }
    get sizeModal(): string {
        return this._sizeModal;
    }

    private _alignLayoutfooter: string = 'pull-center';
    @Input()
    set alignLayoutfooter(alignLayoutfooter: string) {
        switch (alignLayoutfooter) {
            case 'left':
                this._alignLayoutfooter = 'pull-left';
                break;
            case 'right':
                this._alignLayoutfooter = 'pull-right';
                break;
            case 'center':
                this._alignLayoutfooter = 'pull-center';
                break;
            case 'manual':
                this._alignLayoutfooter = '';
                break;
            default:
                this._alignLayoutfooter = 'pull-center';
                break;
        }
    }
    get alignLayoutfooter(): string {
        return this._alignLayoutfooter;
    }

    @Input() showIconClose: boolean = true;
    @Input() showShadow: boolean = true;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    public modalShown: boolean = false;
    modalEl = null;
    id: string = uniqueId('modal_');

    constructor(private _rootNode: ElementRef) { }

    public open() {
        if (this.showShadow) {
            this.modalShown = true;
        }
        this.modalEl.modal('show');
    }

    public close() {
        if (this.showShadow) {
            this.modalShown = false;
        }
        this.modalEl.modal('hide');
    }

    closeInternal() {
        if (this.showShadow) {
            this.modalShown = false;
        }
        this.onClose.next('closeIcon');
        this.close();
    }

    ngAfterViewInit() {
        this.modalEl = $(this._rootNode.nativeElement).find('div.modal');
    }
}


export function uniqueId(prefix: string): string {
    let modal_id: number = 0;
    return prefix + ++modal_id;
}
